import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGuard } from "./core/guards/auth.guard";
import { RolesGuard } from "./core/guards/roles.guard";
import { LayoutComponent } from "./layouts/layout.component";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () => import("./pages/auth/auth.module").then(m => m.AuthModule)
  },
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGuard, RolesGuard],
    loadChildren: () => import("./pages/pages.module").then(m => m.PagesModule)
  },
  {
    path: "token/:idClient",
    loadChildren: () => import("./pages/token/token.module").then(m => m.TokenModule)
  },
  {
    path: "token/:idClient/:idRequest",
    loadChildren: () => import("./pages/token/token.module").then(m => m.TokenModule)
  },
  {
    path: "token-redirect/:component/:idClient",
    loadChildren: () => import("./pages/open-finance/open-finance.module").then(m => m.OpenFinanceModule)
  },
  {
    path: "open-finance/:idClient",
    loadChildren: () => import("./pages/open-finance/open-finance.module").then(m => m.OpenFinanceModule)
  },
  {
    path: "store/:name",
    loadChildren: () => import("./pages/store/store.module").then(m => m.StoreModule)
  }
  // { path: '**', component: Error404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: "top" })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
